import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    OrderStatuses,
} from 'app/enums/label.enums'

import {
    DailyOpsFields,
} from '../dailyOps.types'

const config: SkyNetTableConfig<DailyOpsFields> = {
    name: 'DailyOps.ToBeConfirmed',
    tabs: [{
        name: 'To Be Confirmed',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'from',
                filterField: 'from',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'to',
                filterField: 'to',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'orderStatus',
                filterField: 'orderStatus',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: OrderStatuses,
            },
            {
                name: 'customerLocationName',
                filterField: 'customerLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                labelKey: 'Prebooking.pricingAccount',
                filterType: FilterType.Array,
            },
            {
                name: 'forwarderLocationName',
                filterField: 'forwarderLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'originLocationLocationName',
                filterField: 'originLocationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'handoverPointLocationName',
                filterField: 'handoverPointLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'requestedHandover',
                componentName: 'ContainerSelectionUntil',
                headerProps: {
                    children: 'Requested Handover In',
                },
            },
        ],
    }],
}

export default config
